/* eslint-disable react/no-danger */
import PropTypes from 'prop-types';
import uniqid from 'uniqid';

import './sectionParagraph.scss';

const SectionParagraph = ({ paragraph, sectionHeading }) => {
  if (!paragraph) {
    return null;
  }

  const { heading, content, listItems } = paragraph;
  const headerText = heading || sectionHeading;
  return (
    <div className="gw-section-paragraph">
      {headerText && <h3>{headerText}</h3>}
      <span dangerouslySetInnerHTML={{ __html: content }} />
      {listItems && listItems.length > 0 && (
        <ul>
          {listItems.map((item) => {
            return (
              <li key={uniqid('list-item-')}>
                <span dangerouslySetInnerHTML={{ __html: item.content }} />
              </li>
            );
          })}
        </ul>
      )}
    </div>
  );
};

SectionParagraph.propTypes = {
  paragraph: PropTypes.shape({
    content: PropTypes.string,
    heading: PropTypes.string,
    listItems: PropTypes.arrayOf(
      PropTypes.shape({ content: PropTypes.string }),
    ),
  }).isRequired,
  sectionHeading: PropTypes.string,
};

SectionParagraph.defaultProps = {
  sectionHeading: '',
};

export default SectionParagraph;
